import { render, staticRenderFns } from "./How.vue?vue&type=template&id=645bb797"
import script from "./How.vue?vue&type=script&lang=js"
export * from "./How.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports